import { GrpcMeta } from './grpc-transport-context';

export const FETCH_ORIGIN = new GrpcMeta<string>();
